import { Map } from 'immutable';
import { getDefaultPath } from '../../helpers/urlSync';
import actions, { getView } from './actions';

const preKeys = getDefaultPath();

const initState = new Map({
  collapsed: window.innerWidth > 1220 ? false : true,
  view: getView(window.innerWidth),
  height: window.innerHeight,
  openDrawer: false,
  openKeys: preKeys,
  current: preKeys,
  notifications:[],
  apps: null,
  isAppUpdate: false
});
export default function appReducer(state = initState, action) {
  switch (action.type) {
    case actions.COLLPSE_CHANGE:
      return state.set('collapsed', !state.get('collapsed'));
    case actions.UPDATE_REDUX:
      return state.set('apps', action.payload);
    case actions.COLLPSE_OPEN_DRAWER:
      return state.set('openDrawer', !state.get('openDrawer'));
    case actions.UPDATE_SIDEBAR:
      return state.set('isAppUpdate', !state.get('isAppUpdate'));
    // case actions.SET_PAYERS:
    //   return state.set('payersList',action.payload);
    //   case actions.SET_CLIENTS:
    //     console.log('payload',action.payload);
    //   return state.set('clientList',action.payload);
    // case actions.SET_NOTIFICATION:
    //   const notifications = state.get('notifications');
    //   notifications.push({id:notifications.length+1,type : action.notificationType,message:action.message,description:action.description});
    //   return state.set('notifications', notifications);

    //   case actions.UNSET_NOTIFICATION:
    //     const notification = state.get('notifications');
    //     const updatedNotification = action.value === null ? [] : notification.filter(({id}) => id !== action.value);
    //   return state.set('notifications', updatedNotification);

    case actions.TOGGLE_ALL:
      if (state.get('view') !== action.view || action.height !== state.height) {
        const height = action.height ? action.height : state.height;
        return state
          .set('collapsed', action.collapsed)
          .set('view', action.view)
          .set('height', height);
      }
      break;
    case actions.CHANGE_OPEN_KEYS:
      return state.set('openKeys', action.openKeys);
    case actions.CHANGE_CURRENT:
      return state.set('current', action.current);
    case actions.SET_PREMIUM_STATUS:
      /* subscriptionDue is of type Date ISO String and
      ** isOnTrial is of type number with value 1 when trial is running and
      ** value 0 when trial expired
      */
      const premiumStatus = new Date(action.subscriptionDue) > new Date();

      return state
        .set('hasPremium', premiumStatus)
        .set('isOnTrial', !!(parseInt(action.isOnTrial)))
        .set('customerId', action.customerId);

    default:
      return state;
  }
  return state;
}
